import * as filestack from 'filestack-js';

export const getFilePicker = (config, onUploadCallback) => {
  const {
      location,
      container,
      region,
      fileStackSources,
      fileStackAccept,
      fileStackPolicy,
      fileStackSignature,
      fileStackApiKey,
      fileStackCname
  } = config;

  const onUploadComplete = async result => {
      const file = { ...result.filesUploaded[0] };
      const fileExtension = file.key.split('.').pop();
      const harmfulExtensions = ['js', 'html', 'htm'];
      if (!harmfulExtensions.includes(fileExtension)) {
          file.url += `?policy=${fileStackPolicy}&signature=${fileStackSignature}`;
          onUploadCallback(file);
      }
  };

  const getFileStackOptions = () => ({
      storeTo: {
          location,
          container,
          region
      },
      fromSources: fileStackSources,
      accept: fileStackAccept,
      onUploadDone: file => onUploadComplete(file)
  });

  const client = filestack.init(fileStackApiKey, {
      security: {
        policy: fileStackPolicy,
        signature: fileStackSignature
      },
      cname: fileStackCname
  });

  return client.picker(getFileStackOptions());
}
